/** @format */

export function GetUserPreference(appName, apiBaseUrl) {
  return window.httpService.get("".concat(apiBaseUrl, "GetUserPreference"), null, {
    resourceName: appName
  }).then(window.httpService.handleResponse).catch(window.httpService.handleError);
}
export function SaveUserPreference(appName, apiBaseUrl, data) {
  return window.httpService.post("".concat(apiBaseUrl, "SaveUserPreference"), null, {
    resourceName: appName,
    stateContent: data
  }).then(window.httpService.handleResponse).catch(window.httpService.handleError);
}